<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'ColonneDroiteArticle'
});
</script>
<template>
  <ka-container
    code="colonne-droite-article"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <ka-text code="texte">
      <span v-html="t('colonneDroiteArticle.texte.value', `De bons conseils pour faire financer à 100% un projet de formation ? Par ici 👇`)" />
    </ka-text>
    <ka-button
      code="prendre-rendez-vous"
      :options="{
        ripple: true,
        href: `https://meetings.hubspot.com/christophe-pramil`,
        ariaLabel: `button`,
        click: componentInstance.prendreRendezVousClick
      }">
      <span v-html="t('colonneDroiteArticle.prendreRendezVous.value', `Prendre rendez-vous`)" />
    </ka-button>
    <ka-image
      code="image"
      :options="{
        animationIn: `fadeIn`,
        href: `https://www.matchers.fr/expert/306`,
        ariaLabel: `image`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        click: componentInstance.imageClick,
        alt: `Image`
      }"
      value="https://ucarecdn.com/67c3f863-3536-4ab4-8b9c-523a3f7b919a/Expert-Olivia.svg" />
    <ka-image
      code="image-1"
      :options="{
        animationIn: `fadeIn`,
        href: `https://www.matchers.fr/expert/195`,
        ariaLabel: `image`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        click: componentInstance.image1Click,
        alt: `Image`
      }"
      value="https://ucarecdn.com/8beecf17-f354-4f05-934c-f797b158911e/Expert- Olivier.svg" />
    <ka-image
      code="image-2"
      :options="{
        animationIn: `fadeIn`,
        href: `https://www.matchers.fr/expert/398`,
        ariaLabel: `image`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        click: componentInstance.image2Click,
        alt: `Image`
      }"
      value="https://ucarecdn.com/118483a8-2431-4039-8d96-05842d54c1f2/Expert-Geoffroy.svg" />
    <!-- Container -->
    <ka-container code="container">
      <ka-text code="etre-accompagne-gratuitement">
        <span v-html="t('colonneDroiteArticle.container.etreAccompagneGratuitement.value', `Être accompagné gratuitement`)" />
      </ka-text>
      <ka-text code="vous-navez-pas-le">
        <span v-html="t('colonneDroiteArticle.container.vousNavezPasLe.value', `Vous n’avez pas le temps de chercher la formation idéale ? Contactez-nous ! En 15 min chrono nous identifions vos besoins pour vous composer une formation adaptée à vos outils, votre équipe et vos objectifs !`)" />
      </ka-text>
      <ka-button
        code="button-1"
        :options="{
          ripple: true,
          href: `https://meetings.hubspot.com/christophe-pramil`,
          ariaLabel: `button`,
          click: componentInstance.button1Click
        }">
        <span v-html="t('colonneDroiteArticle.container.button1.value', `Prendre rendez-vous`)" />
      </ka-button>
    </ka-container>
    <ka-image
      code="image-3"
      :options="{
        animationIn: `fadeIn`,
        href: `https://www.matchers.fr/expert/241`,
        ariaLabel: `image`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        click: componentInstance.image3Click,
        alt: `Image`
      }"
      value="https://ucarecdn.com/317c648e-e707-43df-8f87-df66b9823bdf/profil_expert_Anne-Sophie.svg" />
    <ka-image
      code="image-4"
      :options="{
        animationIn: `fadeIn`,
        href: `https://www.matchers.fr/expert/342`,
        ariaLabel: `image`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        click: componentInstance.image4Click,
        alt: `Image`
      }"
      value="https://ucarecdn.com/7c194199-ff26-4531-9634-315cb45ccd62/Expert-JF.svg" />
    <ka-image
      code="image-5"
      :options="{
        animationIn: `fadeIn`,
        href: `https://www.matchers.fr/expert/288`,
        ariaLabel: `image`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        click: componentInstance.image5Click,
        alt: `Image`
      }"
      value="https://ucarecdn.com/ad4da1bc-6690-43b0-8d91-d487c69df7c0/Expert-Jules.svg" />
    <ka-image
      code="image-6"
      :options="{
        animationIn: `fadeIn`,
        href: `https://www.matchers.fr/expert/622`,
        ariaLabel: `image`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        click: componentInstance.image6Click,
        alt: `Image`
      }"
      value="https://ucarecdn.com/2555b865-47ad-413d-b2dc-418cab6529d4/Expert- Vanessa.svg" />
    <ka-image
      code="image-7"
      :options="{
        animationIn: `fadeIn`,
        href: `https://www.matchers.fr/expert/194`,
        ariaLabel: `image`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        click: componentInstance.image7Click,
        alt: `Image`
      }"
      value="https://ucarecdn.com/ecbeff65-7148-43ef-b407-52c8a47b9032/Experte-digital-déborah.svg" />
    <ka-image
      code="image-8"
      :options="{
        animationIn: `fadeIn`,
        href: `https://www.matchers.fr/expert/247`,
        ariaLabel: `image`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        click: componentInstance.image8Click,
        alt: `Image`
      }"
      value="https://ucarecdn.com/286f36ef-358f-494e-8b78-2b5dfcb6f147/Expert- Tuka.svg" />
    <ka-image
      code="image-9"
      :options="{
        animationIn: `fadeIn`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        alt: `Image`
      }"
      value="https://ucarecdn.com/278725d6-e7b3-41e1-a175-35f1a4c32a16/Expert-Julien (1).svg" />
    <ka-image
      code="image-10"
      :options="{
        animationIn: `fadeIn`,
        href: `https://www.matchers.fr/expert/274`,
        ariaLabel: `image`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        click: componentInstance.image10Click,
        alt: `Image`
      }"
      value="https://ucarecdn.com/58929996-da0a-4035-9cd0-d84857604f06/Expert- Joanna.svg" />
    <ArgToutSavoirFinancementsDispo instance-class="arg-tout-savoir-financements-dispo--c32" />
    <ka-image
      code="image-11"
      :options="{
        animationIn: `fadeIn`,
        href: `https://www.matchers.fr/expert/158`,
        ariaLabel: `image`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        click: componentInstance.image11Click,
        alt: `Image`
      }"
      value="https://ucarecdn.com/5c96af61-054e-481a-895d-c0b3d26ba55f/Expert- Jean-Dominique.svg" />
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { colonneDroiteArticleComponent } from './store'
import ArgToutSavoirFinancementsDispo from '~/components/ArgToutSavoirFinancementsDispo/index.vue'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c32')
const component = colonneDroiteArticleComponent()
const componentInstance = component.newStoreInstance()
withDefaults(defineProps<{
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

syncComponentStore(componentInstance)
</script>
